export default {
  fr: {
    Ui: {
    }
  },
  en: {
    Ui: {
    }
  }
}



// WEBPACK FOOTER //
// ./src/commons/lang/UiLang.js